module.exports = __webpack_public_path__ + "img/save.6995abb3.png";